import api from '@/http'

const state = () => ({})

const getters = {}

const actions = {
  searchManagers(ctx, query) {
    return new Promise((resolve, reject) => {
      api
        .get(`search/managers`, { params: { query } })
        .then(({ data, response }) => {
          resolve(data, response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchGlobal(ctx, query) {
    return new Promise((resolve, reject) => {
      api
        .get(`search`, { params: { query } })
        .then(({ data, response }) => {
          resolve(data, response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
